import cn from 'classnames'
import { isString } from 'lodash'
import React from 'react'

import styles from './Divider.module.scss'
import { DividerDirection, DividerVariant } from './lib/types'

interface DividerProps {
  direction?: DividerDirection
  variant?: DividerVariant
  size?: string | number
  className?: string
  label?: React.ReactNode
}

function Divider({ label, direction = 'horizontal', variant = 'default', size, className }: DividerProps) {
  return (
    <div
      className={cn(styles.root, direction && styles[direction], variant && styles[variant], className)}
      style={
        {
          ...(direction === 'horizontal' && { width: isString(size) ? size : `${size}px` }),
          ...(direction === 'vertical' && { height: isString(size) ? size : `${size}px` }),
        } as React.CSSProperties
      }
    >
      {label && <span className={styles.label}>{label}</span>}
      <span className={styles.line} />
    </div>
  )
}

export default Divider
